import { render, staticRenderFns } from "./AdditionnalLinks.vue?vue&type=template&id=882019b2&scoped=true"
import script from "./AdditionnalLinks.vue?vue&type=script&lang=js"
export * from "./AdditionnalLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882019b2",
  null
  
)

export default component.exports